import { ApiQueryConfig } from 'api/types';
import { createApiEndpoint } from 'api/utils';
import { URLS } from 'config';
import { EncryptionKey, EncryptionKeysPathParams } from './types';

type GetEncryptionKeysConfig = ApiQueryConfig<
  EncryptionKey[],
  EncryptionKeysPathParams
>;

const url = `${URLS.app}/api/encryption/$subscriptionId/keys`;

export const getEncryptionKeys = createApiEndpoint<GetEncryptionKeysConfig>({
  url,
  method: 'GET',
});
